import { useEffect, useState } from "react";
import { useAppStore } from "@/common/states/store"; // Ajuste o caminho se necessário
import { VERSION_UPDATE_EVENT } from "../../utils/version-event"; // Importe o evento que criamos antes
import {
  useCompanyStore,
  useCompanyStoreActions,
} from "@/common/states/store/Company";
import { useCompanyAccessStore } from "@/common/states/store/CompanyAccess";

const VERSION_KEY = "@Locavibe:app_version";

export const VersionUpdateToast = () => {
  const [newVersion, setNewVersion] = useState<string | null>(null);

  // Hooks das Stores (Mesma lógica do seu Logout)
  const { setAllSelection } = useCompanyStoreActions();
  const { removeCompanyAccess } = useCompanyAccessStore();
  const { setProfile } = useAppStore((state) => state.auth);

  useEffect(() => {
    // Função que "ouve" o evento disparado pelo makeRequest
    const handleVersionMismatch = (event: Event) => {
      const customEvent = event as CustomEvent;
      // Só atualiza se ainda não estiver exibindo (evita re-render desnecessário)
      if (!newVersion) {
        setNewVersion(customEvent.detail);
      }
    };

    window.addEventListener(VERSION_UPDATE_EVENT, handleVersionMismatch);

    return () => {
      window.removeEventListener(VERSION_UPDATE_EVENT, handleVersionMismatch);
    };
  }, [newVersion]);

  const handleUpdate = () => {
    if (!newVersion) return;

    setAllSelection();
    removeCompanyAccess();
    useCompanyStore.setState({ availableCompanies: [] });
    setProfile(null);

    const keysToKeep: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("@@auth0spajs@@")) {
        keysToKeep.push(key);
      }
    }

    const auth0Data = keysToKeep.map((key) => ({
      key,
      val: localStorage.getItem(key),
    }));

    localStorage.clear();
    sessionStorage.clear();

    auth0Data.forEach((item) => {
      if (item.val) localStorage.setItem(item.key, item.val);
    });

    localStorage.setItem(VERSION_KEY, newVersion);

    window.location.reload();
  };

  if (!newVersion) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.toastContainer}>
        <div style={styles.content}>
          <div style={styles.iconArea}>🚀</div>
          <div style={styles.textArea}>
            <strong style={styles.title}>Nova atualização disponível!</strong>
            <p style={styles.message}>
              Versão <strong>{newVersion}</strong> detectada. Atualize para
              carregar as novidades e evitar erros.
            </p>
          </div>
        </div>
        <button
          onClick={handleUpdate}
          style={styles.button}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#1d4ed8")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "#2563eb")
          }
        >
          ATUALIZAR SISTEMA
        </button>
      </div>
    </div>
  );
};

// --- Estilos CSS (Inline para funcionar em qualquer projeto) ---
const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: "fixed",
    bottom: "24px", // Distância do fundo
    left: "0",
    width: "100%",
    display: "flex",
    justifyContent: "center", // Centraliza na tela
    zIndex: 999999, // Garante que fique acima de modais e menus
    pointerEvents: "none", // Permite clicar "através" da área transparente
  },
  toastContainer: {
    pointerEvents: "auto", // Reabilita o clique no botão
    backgroundColor: "#1f2937", // Cinza escuro (estilo dark)
    color: "#ffffff",
    padding: "16px 24px",
    borderRadius: "8px",
    boxShadow:
      "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    border: "1px solid #374151",
    display: "flex",
    alignItems: "center",
    gap: "24px",
    maxWidth: "90%",
    width: "550px",
    animation: "slideUp 0.4s ease-out", // Animação de entrada
  },
  content: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    flex: 1,
  },
  iconArea: {
    fontSize: "24px",
  },
  textArea: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "4px",
  },
  message: {
    fontSize: "14px",
    color: "#9ca3af", // Cinza claro
    margin: 0,
    lineHeight: "1.4",
  },
  button: {
    backgroundColor: "#2563eb", // Azul primário
    color: "white",
    border: "none",
    padding: "12px 20px",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "700",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background-color 0.2s ease",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
  },
};
